// extracted by mini-css-extract-plugin
module.exports = {"startContractPageRoot":"startContractPageRoot--caebd"};